import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Stack } from '@mui/material';
import validator from 'validator';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { DialogContent, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Check from '../../../assets/Circle.png';
import technology from '../../../assets/technology.png';
import science from '../../../assets/science.png';
import arts from '../../../assets/arts.png';
import health from '../../../assets/health.png';
import sports from '../../../assets/sports.png';
import music from '../../../assets/music.png';
import self from '../../../assets/self.png';
import thk1 from '../../../assets/thk1.png';
import thk2 from '../../../assets/thk2.png';
import astrology from '../../../assets/astrology.png';
import bgImage from '../../../assets/bg-interest.png';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import './Interest.css'
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { AmplifyS3Image } from "@aws-amplify/ui-react/legacy";
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import SubInterest from './SubInterest';
import { Auth, API, graphqlOperation, Hub } from 'aws-amplify';
import { createInterestUser, createSubinterestUser } from '../../../graphql/mutations';
import Loader from '../Loader';
import { addEventLog, deleteAllInterest } from '../../auth/util/util';
import { getUserInterestsAction, getUserSubInterestsAction } from '../../actions/profileActions';
import axios from "axios"
import fetchSearchItemsNextToken from '../../../graphql/fetchSearchItemsNextToken';
import * as queries from "../../../graphql/queries";
import { useNavigate } from 'react-router-dom';
import ShowImage from '../AddMore/ShowImage';


function Interests(props) {
    const dispatch = useDispatch();
    const profileReducer = useSelector((state) => state.profileReducer);
    const [openVerification, setOpenVerification] = useState(true);
    const [showIntersets, setShowIntersets] = useState(true);
    const [showSelIntersets, setShowSelIntersets] = useState(false);
    const [showThankYou, setshowThankYou] = useState(false);
    const [interestArr, setInterestArr] = useState([]);
    const [selInterestArr, setSelInterestArr] = useState([]);
    const [openTost, setOpenTost] = useState(false);
    const [toastType, setToastType] = useState('success');
    const [Tost_msg, setTost_msg] = useState('This is a success message!');
    const [selSubInterestArr, setSelSubInterestArr] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    let navigate = useNavigate();
    const[changeIcon,setChnageIcon] = useState(false)
    

    useEffect(() => {
        if (profileReducer?.interests?.length > 0) {
            const checkboxesData = profileReducer?.interests.map((item) => ({
                ...item,
                checked: false,
            }));
            let updatedArray = [];
            if(profileReducer?.userInterests?.length>0)
            {
                console.log('interests', checkboxesData);
                console.log('User interests', profileReducer?.userInterests);

                updatedArray = checkboxesData.map((item) => {
                    const matchingItem = profileReducer?.userInterests.find((otherItem) => otherItem.interest.id === item.id);
                    if (matchingItem) {
                      return { ...item, checked: true };
                    }
                    return item;
                  });
                console.log('User interests update', updatedArray);
            }
            else
            {
                updatedArray=checkboxesData
            }
            setInterestArr(updatedArray)
            
        }

    }, [profileReducer.interests])

    useEffect(() => {
     if(props.openPopup==true)
     {
        setOpenVerification(true)
     }
     if(props.openPopup==false)
     {
        setOpenVerification(false)
     }
    }, [props.openPopup])
    



    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.up('md'));


    const handleCloseVerification = (event, reason) => {
        // console.log(reason);
        if (reason && reason == "backdropClick") {
            setOpenVerification(true);
        }
        else {
            setOpenVerification(false);
            localStorage.removeItem("loginFirstTime");
        }

    };

    const getSelInterest = () => {
        setOpenTost(false);
        setToastType('')
        setTost_msg('');
        const lenArr = interestArr.filter(item => item.checked === true);
        console.log('lenArr', lenArr)
        if (lenArr.length >= 2) {
            setShowIntersets(false)
            setShowSelIntersets(true)
            setshowThankYou(false)
            setSelInterestArr(lenArr)
        }
        else {
            setOpenTost(true);
            setToastType('error')
            setTost_msg('Please pick minimum two subjects');
        }

    }

    const contains = (arr, obj) => {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] === obj) {
                return true;
            }
        }
        return false;
    }

    const getThankYou = async() => {
        console.log('selInterestArr',selInterestArr);
        console.log('selInterestArr',selSubInterestArr);
        setShowLoader(true)
        setOpenTost(false);
        setToastType('')
        setTost_msg('');
        const newArr=selInterestArr.map(item=>{
            if(selSubInterestArr[item.id]?.length >= 1)
            {
                return false
            }
            else
            {
                return item
            }
        });
        const isError=newArr.filter(item=>item!==false)
        // console.log('selInterestArr newArr', newArr);
        if(isError.length===0)
        {
            let userDetailsID = localStorage.getItem('userDetailsID')
            if(userDetailsID === null || userDetailsID === undefined || userDetailsID === ""){
                let userEmail = localStorage.getItem('email')
                if(userEmail){
                    let user = await fetchSearchItemsNextToken({
                        query: queries.searchUserMasters,   
                        variables: {
                            filter: {
                              email: { eq: userEmail },
                            },
                            limit: 500,
                        },
                    })
                    if(user.length > 0){
                        console.log("check master ", user[0])
                        let userDetails = await fetchSearchItemsNextToken({
                            query: queries.searchUserProfileDetails,   
                            variables: {
                                filter: {
                                    userProfileDetailsUserMasterId: { eq: user[0].id },
                                },
                                limit: 500,
                            },
                        })
                        if(userDetails.length > 0){
                            console.log("check details ", userDetails[0])
                            localStorage.setItem("userDetailsID",userDetails[0].id)
                        }else{
                            console.log("check no details ", userDetails)
                            navigate(process.env.PUBLIC_URL+"/logout");
                            return
                        }
                    }else{
                        console.log("check no master ", user)
                        navigate(process.env.PUBLIC_URL+"/logout");
                        return
                    }
                }else{
                    console.log("check no email")
                    navigate(process.env.PUBLIC_URL+"/logout");
                    return
                }
            }
            await deleteAllInterest(localStorage.getItem('userDetailsID'))
            let interCnt=0;
            let subinterCnt=0;
            let siArr = []
            let iArr = []
            for (const [key, value] of Object.entries(selSubInterestArr)) {
                if(value.length>0)
                {
                    const cardItemInsertParam = {interestID: key, interestUsersId: key, userInterestID: localStorage.getItem('userDetailsID'), userProfileDetailsInterestsId: localStorage.getItem('userDetailsID')};
                    let cardItemInsertQuery=await API.graphql(graphqlOperation(createInterestUser, { input: cardItemInsertParam }));
                    interCnt++
                    if(cardItemInsertQuery)
                    {
                        subinterCnt +=value.length;
                        value.forEach(async(element) => {
                            console.log(element);
                            siArr.push(element.name.replace(/ |,|-|\/|&/gi, '').toLowerCase())
                            !contains(iArr, element.interest.name.replace(/ |,|-|\/|&/gi, '').toLowerCase()) && iArr.push(element.interest.name.replace(/ |,|-|\/|&/gi, '').toLowerCase());
                            const cardItemInsertParam1 ={subinterestID:element.id, subinterestUsersId: element.id, userInterestID: localStorage.getItem('userDetailsID'), userProfileDetailsSubinterestsId: localStorage.getItem('userDetailsID')}
                            let cardItemInsertQuery1=await API.graphql(graphqlOperation(createSubinterestUser, { input: cardItemInsertParam1 }));
                            
                        });
                    }
                }
                
                
            }
            let email = JSON.parse(localStorage.getItem('userDetails')).email
            let str = `{"EMAIL":"${email}","USERSUBINTEREST":"${siArr.join()}","USERINTEREST":"${iArr.join()}"}`
            let data = encodeURIComponent(str)
            console.log("string : ", str)
            console.log("encoded data : ", data)
            
            const apiName = 'welcomeemaildev';
            const path = '/userinterestupdate';
            const myInit = {
                body: {data: data}
            };

            await API.post(apiName, path, myInit)
                .then((result) => {
                    console.log("result : ",result);
                })
                .catch((error) => {
                console.log("lambda Error",error);
                });
            
            if(props?.showCancelBtn===true)
            {
                addEventLog(localStorage.getItem('userDetailsID'),localStorage.getItem('userDetailsID'),'07f1a6d4-b686-4666-98c9-72ccb32cd146','','',`${interCnt}:${subinterCnt}`)
            }
            else
            {
                addEventLog(localStorage.getItem('userDetailsID'),localStorage.getItem('userDetailsID'),'df3caf22-c50b-4a56-8d55-77bca12e4328','','',`${interCnt}:${subinterCnt}`)
            }
            
            setShowIntersets(false)
            setShowSelIntersets(false)
            setshowThankYou(true)
        }
        else
        {
            setOpenTost(true);
            setToastType('error')
            setTost_msg(`Please select atleast one sub-interest for ${Array.prototype.map.call(isError, function(item) { return item.name; }).join(",")}`);
        }
        setShowLoader(false)
    }

    const changeInterests = async() => {
        let userDetailsID = localStorage.getItem('userDetailsID');
        if(userDetailsID)
        {
            await dispatch(getUserInterestsAction(userDetailsID))
            await dispatch(getUserSubInterestsAction(userDetailsID))
        }
        setShowIntersets(true)
        setShowSelIntersets(false)
        setshowThankYou(false)
    }

    const handleCloseTost = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenTost(false);
    };

    const handleCheckboxChange = (id) => {
       
        const updatedCheckboxes = interestArr.map((checkbox) => {
            if (checkbox.id === id) {
                return { ...checkbox, checked: !checkbox.checked };
            }
            return checkbox;
        });
        setInterestArr(updatedCheckboxes);
    };

    const changeSubInterestData = async(interestID,subInterests) => {
        selSubInterestArr[interestID]=subInterests;
        
        setSelSubInterestArr(selSubInterestArr);
        console.log(selSubInterestArr);
    }

    const exitInterest = async() => {
        let userDetailsID = localStorage.getItem('userDetailsID');
        if(userDetailsID)
        {
            await dispatch(getUserInterestsAction(userDetailsID))
            await dispatch(getUserSubInterestsAction(userDetailsID))
        }
        props.onClosePopup(true)
        setOpenVerification(false)
    }
    
    return (
        <>
        <Loader visible={showLoader} />
            <Stack spacing={2} sx={{ width: '100%' }}>
                {/* <Button variant="outlined" onClick={handleClickTost}>
                    Open success snackbar
                </Button> */}
                <Snackbar open={openTost} autoHideDuration={6000} onClose={handleCloseTost}>
                    <Alert variant="filled" onClose={handleCloseTost} severity={toastType} sx={{ width: '100%' }}>
                        {Tost_msg}
                    </Alert>
                </Snackbar>

            </Stack>
            <Box className="bgInterestWrapper">
                <Dialog className="interestWrapper" fullScreen={fullScreen} open={openVerification} onClose={handleCloseVerification} aria-labelledby="responsive-dialog-title" disableEscapeKeyDown={true} disablebackdropclick={"false"} PaperProps={{style :{backgroundImage :`url(${bgImage})`, backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}}}>
                    <DialogContent className='dialogBox dBox'>
                        {showIntersets === true &&
                            <Box className="interestBox">
                                <Box mb={7} textAlign="center" className="top">
                                    <Typography variant='h6'>Pick 2 or more areas you are interested in</Typography>
                                    <Typography variant='p'>We'll use this to customise your MySphere experience</Typography>
                                </Box>
                                {interestArr?.length > 0 &&
                                    <Box className="ibox">
                                        {interestArr.map((item, index) =>
                                            <Box className="smBox" onClick={() => handleCheckboxChange(item.id)}>
                                                <Box className={`bg ${item.checked} ${item.checked === true ? 'active' : ' '}`}>
                                                    {/* <img src={self} alt="self" className='default' /> */}
                                                    {/* {item.checked === false && */}
                                                        {/* <AmplifyS3Image key={item.image} imgKey={item.image} imgProps={{ className: 'default' }} /> */}
                                                        <ShowImage 
                                                         key={item.image} 
                                                         url={item.image} 
                                                         className={'default'} 
                                                        />
                                                    {/* } */}
                                                    <Box className="textOverlay">
                                                        {item.checked === true &&
                                                            <img src={Check} alt="check" className="check" />
                                                        }
                                                        <Typography>{item.name}</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}
                                      
                                    </Box>
                                }
                                <Stack direction="row" justifyContent="center" spacing={2} mt={3}>
                                {props?.showCancelBtn===true &&
                                    <Button variant="text" className='skipBtn' onClick={() => exitInterest()}>
                                    Cancel
                                    </Button>
                                }
                                    <Button variant="contained" className='nBtn' endIcon={<ArrowForwardIcon />} onClick={() => getSelInterest()}>
                                        Next
                                    </Button>
                                </Stack>
                            </Box>
                        }
                        {showSelIntersets === true &&
                            <>
                                <Box mb={7} textAlign="center" className="top">
                                    <Typography variant='h6'>Great! Now select at least one specialised area for each of your interests</Typography>
                                    <Typography variant='p'>We'll use this to customise your MySphere experience</Typography>
                                </Box>
                                {selInterestArr.length > 0 &&
                                    <Box className="accwrapeer" px={3}>
                                        {selInterestArr.map(item =>
                                            <Accordion className='accBox' defaultExpanded={true}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    className='aSummary'
                                                >
                                                    <Typography className='accTitle'>{item.name}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <SubInterest interestID={item.id} onChangeTags={(data)=>changeSubInterestData(item.id,data)} />
                                                </AccordionDetails>
                                            </Accordion>
                                        )}

                                        <Stack direction="row" justifyContent="center" spacing={2} mt={3}>
                                            <Button variant="text" className='skipBtn' onClick={() => changeInterests()}>
                                                Back
                                            </Button>
                                            <Button variant="contained" className='nBtn' endIcon={<CheckIcon />} onClick={() => getThankYou()}>
                                                Done
                                            </Button>
                                        </Stack>
                                    </Box>
                                }
                            </>
                        }
                        {showThankYou === true &&
                            <>
                                <Box mb={7} textAlign="center" className="top">
                                    <Typography variant='h6'>Woohooo! Great!</Typography>
                                    <Typography variant='p'>We are now all set to create a more personalised MySphere experience for you.</Typography>
                                </Box>
                                <Box px={3}>
                                    <Box textAlign='center' mb={2}>
                                    {localStorage.getItem('gender')==='male' ?
                                    <img src={thk1} className="img-fluid" alt="thank you" />
                                        :
                                    <img src={thk2} className="img-fluid" alt="thank you" />
                                    }
                                    </Box>
                                    <Box textAlign='center'>
                                        <Button variant="outlined" className='chnge' onClick={() => changeInterests()}>Change Interests</Button>
                                        <Button variant="outlined" className='chnge bgChange' onClick={() => exitInterest()}>Go to MySphere</Button>
                                    </Box>
                                </Box>
                            </>
                        }
                    </DialogContent>


                </Dialog>
            </Box>

        </>

    )
}

export default Interests